import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import preLoaderCake from "../assets/img/preLoaderCake.webp";
import menubarIconMobile from "../assets/img/menubarIconMobile.webp";
import { Img } from "react-image";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function Navbar() {
  /*---------- 01. On Load Function ----------*/
  useEffect(() => {
    setTimeout(() => {
      $(".preloader").fadeOut();
    }, 500);

    /*---------- 02. Preloader ----------*/
    if ($(".preloader").length > 0) {
      $(".preloaderCls").each(function () {
        $(".preloaderCls").on("click", function (e) {
          e.preventDefault();
          $(".preloader").css("display", "none");
        });
      });
    }
  }, []);

  const [isLoaded, setIsLoaded] = useState(false);
  const [menuBarImage, setMenuBarImage] = useState(false);

  useEffect(() => {
    window.addEventListener("load", function () {
      setIsLoaded(true);
    });
  }, [isLoaded]);

  /*---------- 03. Mobile Menu Active ----------*/
  const options = {
    menuToggleBtn: ".th-menu-toggle",
    bodyToggleClass: "th-body-visible",
    subMenuClass: "th-submenu",
    subMenuParent: "th-item-has-children",
    subMenuParentToggle: "th-active",
    meanExpandClass: "th-mean-expand",
    appendElement: '<span className="th-mean-expand"></span>',
    subMenuToggleClass: "th-open",
    toggleSpeed: 400,
  };

  const opt = {
    ...options,
    // Add any additional options you want to customize
  };
  useEffect(() => {
    const handleMenuToggle = () => {
      const menu = document.querySelector(".th-menu-wrapper");

      if (!menu) {
        console.error("Menu element not found");
        return;
      }

      menu.classList.toggle(opt.bodyToggleClass);

      const subMenus = menu.querySelectorAll(`.${opt.subMenuClass}`);
      subMenus.forEach((subMenu) => {
        subMenu.style.display = "none";
        subMenu.parentElement.classList.remove(opt.subMenuParentToggle);
      });
    };

    const handleSubMenuToggle = (element) => {
      const submenu =
        element.nextElementSibling || element.previousElementSibling;
      if (submenu) {
        element.parentElement.classList.toggle(opt.subMenuParentToggle);
        submenu.style.transition = `height ${opt.toggleSpeed}ms`;
        submenu.style.display =
          submenu.style.display === "none" ? "block" : "none";
      }
    };

    const menuToggleBtns = document.querySelectorAll(opt.menuToggleBtn);
    menuToggleBtns.forEach((toggleBtn) => {
      toggleBtn.addEventListener("click", handleMenuToggle);
    });

    const expandTogglers = document.querySelectorAll(`.${opt.meanExpandClass}`);
    expandTogglers.forEach((toggler) => {
      toggler.addEventListener("click", (e) => {
        e.preventDefault();
        handleSubMenuToggle(toggler.parentElement);
      });
    });

    return () => {
      menuToggleBtns.forEach((toggleBtn) => {
        toggleBtn.removeEventListener("click", handleMenuToggle);
      });

      expandTogglers.forEach((toggler) => {
        toggler.removeEventListener("click", handleSubMenuToggle);
      });
    };
  }, []);

  /*---------- 04. Sticky fix ----------*/
  useEffect(() => {
    const handleScroll = () => {
      const topPos = window.scrollY;
      const stickyWrapper = document.querySelector(".sticky-wrapper");
      const menu = document.querySelector(".th-menu-wrapper"); //used to close sidebar menu while scrolling

      if (stickyWrapper) {
        if (topPos > 500) {
          stickyWrapper.classList.add("sticky");
          menu.classList.remove(opt.bodyToggleClass); //used to close sidebar menu while scrolling
        } else {
          stickyWrapper.classList.remove("sticky");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  /*---------- 06. Set Background Image ----------*/
  useEffect(() => {
    // Set Background Image
    if (document.querySelectorAll("[data-bg-src]").length > 0) {
      document.querySelectorAll("[data-bg-src]").forEach((element) => {
        const src = element.getAttribute("data-bg-src");
        element.style.backgroundImage = `url(${src})`;
        element.removeAttribute("data-bg-src");
        element.classList.add("background-image");
      });
    }
    // Set Background Color
    if (document.querySelectorAll("[data-bg-color]").length > 0) {
      document.querySelectorAll("[data-bg-color]").forEach((element) => {
        const color = element.getAttribute("data-bg-color");
        element.style.backgroundColor = color;
        element.removeAttribute("data-bg-color");
      });
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setMenuBarImage(true);
    }, 13000);
  }, []);

  return (
    <>
      {/* <!--==============================
     Preloader
  ==============================--> */}
      <div className="preloader">
        <div className="preloader-inner">
          <span className="loader">
            {/* <LazyLoadImage
              alt="Zeppoli Preloader Image"
              effect="opacity"
              src={preLoaderCake}
              placeholderSrc={preLoaderCake}
              threshold={500}
              width={50}
              height={50}
            /> */}
            <Img
              src={preLoaderCake}
              alt="Preloader Image"
              loader={<img src={preLoaderCake} />}
            />
            {/* <img
              src={preLoaderCake}
              alt="Preloader Image"
              srcSet={`${preLoaderCake} 500w,
                      ${preLoaderCake} 1000w`}
              width={"auto"}
              height={"auto"}
            /> */}
          </span>
        </div>
      </div>

      {/* <!--==============================
    Mobile Menu
  ============================== --> */}
      <div className="th-menu-wrapper">
        <div className="th-menu-area text-center">
          <button
            className="th-menu-toggle"
            name="ZeppoliTimeButton"
            aria-label="ZeppoliTimeButton"
          >
            <i className="fal fa-times"></i>
          </button>
          <div className="mobile-logo">
            <Link to="/">
              {/* {isLoaded && ( */}
              <img
                src="https://zeppoli.in/static/media/zeppoliLogoMainHome.3e8364416c68e8bbcff0.webp"
                alt="Zeppoli Logo"
                width={100}
                height={100}
              />
              {/* )} */}
            </Link>
          </div>
          <div className="th-mobile-menu">
            <ul>
              <li className="">
                <Link to="/">Home</Link>
              </li>
              <li className="">
                <Link to="/about">About</Link>
              </li>
              <li className="">
                <Link to="/catalogs">Catalogs</Link>
              </li>
              <li className="">
                <Link to="/gallery">Gallery</Link>
              </li>
              <li className="menu-item-has-children">
                <Link to="/location">Location</Link>
              </li>
              <li>
                <Link to="/franchise">Franchise</Link>
              </li>
              <li>
                <Link to="/career">Career</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* <!--==============================
	Header Area
==============================--> */}
      <header className="th-header header-layout2">
        <div
          className="header-shape1"
          style={{ backgroundColor: "#eaae78" }}
        ></div>
        <div className="header-top">
          <div className="container">
            <div className="row justify-content-center justify-content-lg-between align-items-center gy-2">
              <div className="col-auto d-none d-lg-block">
                <Link to="/">
                  {isLoaded && (
                    <img
                      src="https://zeppoli.in/static/media/zeppoliLogoMainHome.3e8364416c68e8bbcff0.webp"
                      alt="Zeppoli Logo"
                      srcSet={`https://zeppoli.in/static/media/zeppoliLogoMainHome.3e8364416c68e8bbcff0.webp 100w,
                      https://zeppoli.in/static/media/zeppoliLogoMainHome.3e8364416c68e8bbcff0.webp 300w,
                      https://zeppoli.in/static/media/zeppoliLogoMainHome.3e8364416c68e8bbcff0.webp 500w,
                      https://zeppoli.in/static/media/zeppoliLogoMainHome.3e8364416c68e8bbcff0.webp 1500w,
                      https://zeppoli.in/static/media/zeppoliLogoMainHome.3e8364416c68e8bbcff0.webp 2000w`}
                      width={100}
                      height={100}
                    />
                  )}
                </Link>
              </div>
              <div className="col-auto">
                <div className="th-social">
                  <Link
                    to="https://www.facebook.com/"
                    target="_blank"
                    name="Zeppoli facebook icon"
                    aria-label="Zeppoli facebook icon"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                  <Link
                    to="https://www.instagram.com/zeppoli_foods_official/"
                    target="_blank"
                    name="Zeppoli instgram icon"
                    aria-label="Zeppoli instgram icon"
                  >
                    <i className="fab fa-instagram"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sticky-wrapper">
          <div className="sticky-active">
            <div className="col-auto">
              <div className="header-button m-2">
                <button
                  type="button"
                  className="d-inline-block d-lg-none th-menu-toggle"
                  name="zeppoliBarButton"
                  aria-label="zeppoliBarButton"
                >
                  <img
                    src={menubarIconMobile}
                    alt="Zeppoli Menu Bar Icon"
                    className="menuBarImage"
                    loading="eager"
                    width={"20px"}
                    height={"20px"}
                  />
                </button>
              </div>
            </div>
            {/* Main Menu */}
            <div className={`container`}>
              {/* ${isMenuOpen ? "open" : ""} */}
              <div className="menu-area py-3">
                <div
                  className="row align-items-center justify-content-between"
                  style={{ marginRight: "20px" }}
                >
                  <div className="col-lg-1 col-4 main-menu">
                    <Link to="/">Home</Link>
                  </div>
                  <div className="col-lg-1 col-4 main-menu">
                    <Link to="/about">About</Link>
                  </div>
                  <div className="col-lg-1 col-4 main-menu">
                    <Link to="/catalogs">Catalogs</Link>
                  </div>
                  <div className="col-lg-1 col-4 main-menu">
                    <Link to="/gallery">Gallery</Link>
                  </div>
                  <div className="col-lg-1 col-4 main-menu">
                    <Link to="/location">Location</Link>
                  </div>
                  <div className="col-lg-1 col-4 main-menu">
                    <Link to="/franchise">Franchise</Link>
                  </div>
                  <div className="col-lg-1 col-4 main-menu">
                    <Link to="/career">Career</Link>
                  </div>
                  <div className="col-lg-1 col-4 main-menu">
                    <Link to="/contact">Contact</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Navbar;
